import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { EditableGridService, SystemApiService } from '@cv-invision/core';

@Injectable({ providedIn: 'root' })
export class DataMessageService extends EditableGridService {
	private setReloadlListConfirmation = new BehaviorSubject({});
	private getReloadlListListener = this.setReloadlListConfirmation.asObservable();
	private readonly BASE_URL = '/utils';
	protected scope: string;
	protected entity: string;

	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {
		super();
	}

	/**
	 * Set configuration
	 * @param scope 
	 * @param entity 
	 */
	setConfiguration(scope: string, entity: string): void
	{
		this.scope  = scope;
		this.entity = entity;
	}

	/**
	 * Update the Data Message Configuration
	 */
	updateDataMessageConfiguration(params: Array<any>): Observable<any>
	{
		if (this.entity === 'milestone-message') {
			return this.httpClient.put(`${this.systemApiService.api.orders}${this.BASE_URL}/${this.scope}/mapper/custom-outgoing-messages`, params);
		}

		if (this.entity === 'data-message-type') {
			return this.httpClient.put(`${this.systemApiService.api.orders}${this.BASE_URL}/${this.scope}/mapper/data-messagestype`, params);
		}

		if (this.entity === 'lender-company-message') {
			return this.httpClient.put(`${this.systemApiService.api.orders}${this.BASE_URL}/${this.scope}/mapper/lendercompany-messages`, params);
		}

		if (this.entity === 'assets-on-completion') {
			return this.httpClient.put(`${this.systemApiService.api.orders}${this.BASE_URL}/products/product-assets`, params);
		}
	
		return this.httpClient.put(`${this.systemApiService.api.orders}${this.BASE_URL}/${this.scope}/mapper/${this.entity}`, params);
	}

	/**
	 * GET - Return the list of the Data message configuration mappings.
	 */
	getDataMessageConfiguration(): Observable<any>
	{
		if (this.entity === 'milestone-message') {
			return this.httpClient.get(`${this.systemApiService.api.orders}${this.BASE_URL}/${this.scope}/mapper/custom-outgoing-messages`);
		}

		if (this.entity === 'data-message-type') {
			return this.httpClient.get(`${this.systemApiService.api.orders}${this.BASE_URL}/${this.scope}/mapper/data-messagestype`);
		}

		if (this.entity === 'lender-company-message') {
			return this.httpClient.get(`${this.systemApiService.api.orders}${this.BASE_URL}/${this.scope}/mapper/lendercompany-messages`);
		}

		if (this.entity === 'assets-on-completion') {
			return this.httpClient.get(`${this.systemApiService.api.orders}/products/product-assets`);
		}

		return this.httpClient.get(`${this.systemApiService.api.orders}${this.BASE_URL}/${this.scope}/mapper/${this.entity}`);
	}

	/**
	 * Sets component data communication.
	 * @param data
	 */
	setReloadListConfirmation(data: any): void
	{
		this.setReloadlListConfirmation.next(data);
	}

	/**
	 * Returns si the list should be reloaded.
	 */
	getReloadListConfirmationListener(): Observable<any>
	{
		return this.getReloadlListListener;
	}
}
